export default __webpack_public_path__ + "static/media/SourceSans3-BoldItalic.0d0219a3.ttf";